export default __webpack_public_path__ + "static/media/mode-512.0a618b98.svg";